import EventBus from '../../core/EventBus'

$.nette.ext('events', {
    success: payload => {
        const { component } = payload
        if (component?.name) {
            EventBus.emit('nette:event', component)
        }
    }
})